"use strict";

// dark mode //
let activeTheme = localStorage.getItem("theme");

if(activeTheme != null){
   nuitJour(activeTheme);
}

let themeTrigger = document.querySelector(".darkmode");

if(themeTrigger){
    themeTrigger.addEventListener("click", changement);
}


function nuitJour(theme){

    let image = document.body.querySelector(".images--logo");
    let fleche = document.body.querySelector(".images--fleche");


    document.body.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
    image.setAttribute("data-theme", theme);

    if(theme == "dark"){
        image.setAttribute('src', 'assets/images/logoo--dark.svg');
        if(fleche){
            fleche.setAttribute('src', 'assets/images/back--dark.svg');
        }
    } else if (theme == "light"){
        image.setAttribute('src', 'assets/images/logoo.svg');
        if (fleche){
            fleche.setAttribute('src', 'assets/images/back.svg');
        }
    }
}


function changement(){

    let theme = document.body.getAttribute("data-theme");
 
    if(theme == "dark"){
        nuitJour("light");
    }else{
        nuitJour("dark");
    }
}

//darkmode//

//progress bar//

let progress = document.querySelector(".progress--bar");

if (progress){
    window.onscroll = function() {myFunction()};

    function myFunction() {
    var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var scrolled = (winScroll / height) * 100;
    document.getElementById("progress").style.width = scrolled + "%";
    }
}

//progress bar//


//date//
let date = new Date().getFullYear();
document.getElementById("annee").innerHTML = date;

